import React from 'react';
import {
    CartesianGrid,
    Legend,
    Line,
    LineChart,
    RadialBar,
    RadialBarChart,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis
} from 'recharts';

const SurveyStatistic = ({ data }) => {
    const { surveyName,
        surveyEndDate,
        surveyStartDate,
        noEmployeesInvited,
        noQuestionsCompleted,
        noQuestionsToComplete,
        simpleChartData,
        surveyActive } = data;
    return (
        <div className="jr-card"  style={{marginLeft: '5px', width: '99%'}}>
            <div className="jr-card-header d-flex align-items-center">
                < h3 className="mb-0">Survey statistics for {surveyName}</h3>
            </div>
            <div className="row mb-3">
                <div className="col-6 col-sm-4 col-md-3 col-lg-2">
                    <span className="d-flex align-items-center mb-2">
                        <i className="zmdi zmdi-calendar-check text-muted chart-f20" />
                        <span className="ml-3 text-dark">{noEmployeesInvited}</span>
                    </span>
                    <p className="text-muted">Total invited</p>
                </div>
                <div className="col-6 col-sm-4 col-md-3 col-lg-2">
                    <span className="d-flex align-items-center mb-2">
                        <i className="zmdi zmdi-calendar-note text-muted chart-f20" />
                        <span className="ml-3 text-dark">{noQuestionsCompleted}</span>
                    </span>
                    <p className="text-muted">Questions completed</p>
                </div>
                <div className="col-6 col-sm-4 col-md-3 col-lg-2">
                    <span className="d-flex align-items-center mb-2">
                    <i className="zmdi zmdi-calendar-note text-muted chart-f20" />
                        <span className="ml-3 text-dark">{noQuestionsToComplete}</span>
                    </span>
                    <p className="text-muted">Question to complete</p>

                </div>
                <div className="col-6 col-sm-4 col-md-3 col-lg-2">
                    <span className="d-flex align-items-center mb-2">
                    <i className="zmdi zmdi-calendar-alt text-muted chart-f20" />
                        <span className="ml-3 text-dark">{surveyStartDate}</span>
                    </span>
                    <p className="text-muted">Start date</p>
                </div>
                <div className="col-6 col-sm-4 col-md-3 col-lg-2">
                    <span className="d-flex align-items-center mb-2">
                        <i className="zmdi zmdi-calendar text-muted chart-f20" />
                        <span className="ml-3 text-dark">{surveyEndDate}</span>
                    </span>
                    <p className="text-muted">End date</p>
                </div>
                <div className="col-6 col-sm-4 col-md-3 col-lg-2">
                    <span className="d-flex align-items-center mb-2">
                        <i className="zmdi zmdi-calendar-alt text-muted chart-f20" />
                        <span className="ml-3 text-dark">{surveyActive ? 'Yes': 'No'}</span>
                    </span>
                    <p className="text-muted">Still active</p>
                </div>
            </div>

            <div className="row">
                <div className="col-lg-12 col-12 mb-5 mb-lg-1">
                    <ResponsiveContainer width="100%" height={150}>
                        <LineChart data={simpleChartData}
                            margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
                            <XAxis dataKey="name" />
                            <YAxis />
                            <CartesianGrid strokeDasharray="3 3" />
                            <Tooltip />
                            <Line type='monotone' dataKey='amt' stackId="1" stroke='#59AA2B' fill='#59AA2B' />
                        </LineChart>
                    </ResponsiveContainer>
                </div>
            </div>
        </div >
    );
};

export default SurveyStatistic;



// WEBPACK FOOTER //
// ./components/Agile/OrgDashboard/surveyStatistic/surveyStatistic.js